import Vue from 'vue'
import Router from 'vue-router'
import Modules from '@/config/modules';
import Login from '@/modules/common/pages/login/Login';
import Index from '@/modules/common/pages/index/Index';
import Window from '@/modules/common/pages/Window';
import Start from '@/modules/common/pages/Start';
import store from '@/store';
import NotFoundPage from "@/modules/common/pages/NotFoundPage";

Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
let appRouter = [

];
let windowRouter = [];
Modules.forEach((module, i)=>
{
    let moduleRouter = require('../modules/'+module+'/router');
    if(moduleRouter && moduleRouter.default)
    {
        for(let router of moduleRouter.default)
        {
            if(router.meta && router.meta.windowRouter)
            {
                windowRouter.push(router);
                continue;
            }
            let i = 0;
            for(let aRouter of appRouter)
            {
                if(aRouter.path == router.path)
                {
                    appRouter.splice(i, 1);
                    break;
                }
                i ++;
            }
            appRouter.push(router);
        }
    }
});
// console.log('appRouter', appRouter);
const router =  new Router({
    routes: [
        {
            path: '/start',
            name: 'Start',
            component: Start,
            meta:
            {
                auth: false
            }
        },
        {
            path: '/',
            name: 'Index',
            component: Index,
            meta:
            {
                auth: true
            },
            children: appRouter
        },
        {
            path: '/login',
            name: "Login",
            component: Login,
            meta:
            {
                auth: false
            }
        },
        {
            path:'/window',
            name: 'Window',
            component: Window,
            meta:
            {
                auth: false
            },
            children: windowRouter
        },
        {
            path: '*',
            name: "NotFoundPage",
            component: NotFoundPage,
            meta: {
                caption: '404'
            }
        }
        // {
        //   path: '/404',
        //   name: '404'
        // },
    ]
});
router.beforeEach((to, from, next)=>
{
     // console.log('router', to.fullPath, from.fullPath);
    if(to.meta.auth === false) return next();

    if(store.getters['session/isLogin'])
    {
        next();
    }
    else
    {
        next({
            path: '/start',
            query: {redirect: to.fullPath}
        });
    }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js